import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import { getPageProps } from "@services/initial-calls";

import ContactTop from "@components/antiviruschoice/contactTop";
import FormSection from "@components/antiviruschoice/formSection";

import ForkliftEstimatesWrapper from "@components/layouts/forkliftestimatesWrapper";

export default function NextAutoWarrantyHome(): ReactElement {
    return (
        <ForkliftEstimatesWrapper>
            <div className={`max-w-7xl mx-auto block px-4vw lg:px-4`}>
                <div className="bg-white">
                    <ContactTop iconsFillColor="#fdc611" />
                </div>
                <FormSection iconsFillColor="#fdc611" />
            </div>
        </ForkliftEstimatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Contact Us" });
};
